import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ProjectsService } from "src/app/shared/services/strapi/projects.service";
import { DataRefreshService } from "src/app/shared/services/core/data-refresh.service";

@Component({
  selector: "app-cart",
  templateUrl: "./cart.component.html",
  styleUrls: ["./cart.component.scss"],
})
export class CartComponent implements OnInit, OnDestroy {
  public openCart: boolean = false;
  projectsList: any = [];
  projectListCount: number;
  private refreshSubscription: Subscription;
  constructor(
    private projectService: ProjectsService,
    private router: Router,
    private dataRefreshService: DataRefreshService
  ) {
    this.refreshSubscription = this.dataRefreshService
      .getProjectsRefreshListener()
      .subscribe(() => {
        this.getProjects(); // Call getProjects when a refresh is triggered
      });
  }

  ngOnInit() {
    this.getProjects();
  }

  ngOnDestroy() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  // For Mobile Device
  toggleCart() {
    this.openCart = !this.openCart;
  }

  getProjects(page: number = 1, pageSize: number = 300) {
    this.projectService
      .filterProjectsNeoContactNotConfigured()
      .subscribe((res) => {
        this.projectsList = res.data;
        this.projectListCount = this.projectsList.length;
      });
  }

  goEditProject(id) {
    this.router.navigate(["/strapi-projects/edit", id]);
  }

  closeAndNavigate() {
    this.router.navigate(["/strapi-projects"], {
      queryParams: { search: "unassigned-neo-contact-projects" },
    });
  }
}
